
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { SimpleButton } from '../components.js';
import AudioPlayer from '../audio/AudioPlayer.js';

const DummyMiniPlayer = ({
      publicMode,
      sx,
    }) => {

  return (
    <Stack direction="column">
      <Stack direction="row"
          spacing={1}
          sx={{ width: '100%', alignItems: 'center', ...sx }}>

        <AudioPlayer sources={[]}
                  finalAdCount={0}
                  publicMode={publicMode}
                  ads={[]}
                  contentId="dummy"
                  organizationId="dummy"
                  displayMode="minimal"
                  seekbarColor="black" />

        <SimpleButton sx={{ flexShrink: 0 }}>
          <MoreVertIcon fontSize="medium" />
        </SimpleButton>
      </Stack>
      <Box sx={{
            alignSelf: 'flex-end',
            mt: -1,
            mr: 1,
          }}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            color: 'text.disabled',
          }}
        >
          Powered by&nbsp;
          <Link href="https://voicetopics.xyz"
              underline="none"
              target="_blank"
              sx={{
                color: 'purple.main',
              }} >
            VoiceTopics
          </Link>
        </Typography>
      </Box>
    </Stack>
  );
};

export default DummyMiniPlayer;
